import { funcProto } from './context'
const { toString: contextFuncToString } = funcProto
export default contextFuncToString
